module.exports = __webpack_public_path__ + "static/media/anilist.c04f699f.svg";